import { getAppConfig } from '@services/config';
import { apiHttpService, httpService } from '@services/http';
import { CACHE_TAGS } from '@services/http/http';
import { logger } from '@services/loggers';

import { ApiBannerType, ApiFaqType, ApiModalType, ApiOfferType, ConfigType } from '@app-types/api';
import { FaqType } from '@app-types/cms';

import { marked } from 'marked';

const appConfig = getAppConfig();

export const getCmsOffers = async (): Promise<ApiOfferType | null> => {
    type ResponseType = {
        items: ApiOfferType;
    };

    const path = appConfig.assets.cms.url + '/statics/mCommerceAPI/mco_offres';
    try {
        const res = await httpService.get<ResponseType>(path, undefined, {
            ttl: parseInt(getAppConfig().cache.ttl.products),
            tags: [CACHE_TAGS.PRODUCTS],
        });
        return res.items;
    } catch (error) {
        logger.log('path: ', path);
        logger.log('error getCmsOffers: ', error);
        return null;
    }
};

export const getCmsModal = async (): Promise<ApiModalType | null> => {
    type ResponseType = {
        items: ApiModalType[];
    };
    try {
        const path = appConfig.assets.cms.url + '/statics/mCommerceAPI/mco_modal';
        const res = await httpService.get<ResponseType>(path, undefined, {
            ttl: parseInt(getAppConfig().cache.ttl.config),
            tags: [CACHE_TAGS.CONFIG],
        });
        return res.items[0] || null;
    } catch (error) {
        logger.log('error getCmsModal: ', error);
        return null;
    }
};

export const getDownloadConfiguration = async (): Promise<ConfigType | undefined> => {
    type ResponseType = {
        items: ConfigType[];
    };
    try {
        const path = appConfig.assets.cms.url + '/statics/mCommerceAPI/mco_config';
        const res = await httpService.get<ResponseType>(path, undefined, {
            ttl: parseInt(getAppConfig().cache.ttl.config),
            tags: [CACHE_TAGS.CONFIG],
        });
        return res.items[0];
    } catch (error) {
        logger.log('error fetchMcoConfig: ', error);
        return undefined;
    }
};

export const getPromoBanners = async (): Promise<ApiBannerType[]> => {
    type ResponseType = {
        items: ApiBannerType[];
    };
    try {
        const path = appConfig.assets.cms.url + '/statics/mCommerceAPI/mco_bannieres';
        const result = await httpService.get<ResponseType>(path, undefined, {
            ttl: 50,
            tags: [CACHE_TAGS.CMS],
        });
        const promoBanners = result.items;

        return promoBanners
            .filter((item) => item.enabled)
            .sort((banner1, banner2) => banner1.displayOrder - banner2.displayOrder);
    } catch (error) {
        logger.log('error fetchMcoBanners: ', error);
        return [];
    }
};
export const getFaq = async (): Promise<FaqType[]> => {
    return apiHttpService
        .get<ApiFaqType>(`${appConfig.faqApi.url}`, undefined, {
            ttl: parseInt(getAppConfig().cache.ttl.config), // ttl of config
            tags: [CACHE_TAGS.CMS, CACHE_TAGS.CONFIG],
        })

        .then((response) =>
            response.items?.flatMap((item) =>
                item.questions?.map((q) => ({
                    slug: item.slug,
                    question: q.question,
                    answer: marked.parse(q.reponse).toString(),
                })),
            ),
        )

        .catch((error) => {
            logger.error('[error faqServices]: ', error);
            return [] as FaqType[];
        });
};
